import { PARAGRAPH_KEY, HEADING_KEY } from '@techchange/pm-specs';

/**
 * Determines if a typographical node type is included in the
 * current selection.
 *
 * @param {Object} state  The current editor state.
 *
 * @returns {array} An array of active typography node data containing the node type and attributes.
 *
 */
const getActiveTypography = (state) => {

	const { from, to } = state.selection;

	const paragraphNodeType = state.schema.nodes[PARAGRAPH_KEY];
	const headingNodeType = state.schema.nodes[HEADING_KEY];

	const typographySet = [];

	// Filter out duplicates
	const typeHash = {};

	state.doc.nodesBetween(from, to, (node) => {

		const level = node.attrs && node.attrs.level;
		const nodeKey = `${node.type.name}-${level}`;

		if ((node.type === headingNodeType || node.type === paragraphNodeType) && !typeHash[nodeKey]) {

			typographySet.push({
				type: node.type,
				attrs: node.attrs,
			});

			typeHash[nodeKey] = true;

		}

		return true;

	});

	return typographySet;

};

export default getActiveTypography;
